<template>
  <div class="activityDetails">
    <commonHeader
      :tabs-list="tabsList"
      :tabs-default="activeName"
      @handleTabsClick="handleTabsClick"
    >
      <template #buttons>
        <!-- <button class="common_button" @click="backBtn">返回</button> -->
        <el-button
          plain
          v-if="echoData.allowEditAll || echoData.allowEditBaseInfo || echoData.allowEditExpenseInfo"
          @click="editBtn"
        >
          {{ $t('btn.Edit') }}
        </el-button>
        <el-button plain v-if="echoData.allowRecallEdit" @click="recallBtn">{{ $t('btn.RecallC') }}</el-button>
        <el-button
          plain
          v-if="echoData.allowApprove"
          @click="agreeRejectBtn(1)"
        >
          {{ $t('btn.Agree') }}
        </el-button>
        <el-button
          plain
          v-if="echoData.allowApprove"
          @click="agreeRejectBtn(0)"
        >
          {{ $t('btn.Rejected') }}
        </el-button>
      </template>
    </commonHeader>
    <!-- 活动信息 -->
    <activityBasicInformation
      ref="activityBasicInformation"
      v-if="requestFlage && activeName === 'activityBasicInformation'"
      :echo-data="echoData"
      @jumpTabsHandle="handleTabsClick"
      @refresh="getBasicInfoData"
    />
    <!-- 活动物料 -->
    <activistyMaterial
      v-if="requestFlage && activeName === 'activistyMaterial'"
      :echo-data="echoData"
    />
    <!-- 执行反馈 -->
    <ExecutionFeedback v-if="activeName === 'ExecutionFeedback'" :echo-data="echoData" @jumpTabsHandle="handleTabsClick" />
    <!-- 录入客商 -->
    <travellingTrader v-if="activeName === 'travellingTrader'" :echo-data="echoData" />
    <!-- 活动质量 -->
    <activityQuality v-if="activeName === 'ActivityQuality'" :echo-data="echoData" />
  </div>
</template>

<script>
import { commonServer } from '@/API/home';
import commonHeader from '@/components/commonHeader';
import activityBasicInformation from './children/activityQuery/activityBasicInformation.vue';
import activistyMaterial from './children/activityQuery/activistyMaterial';
import travellingTrader from './children/activityQuery/travellingTrader';
import { activityQuery, activityQueryDetails } from './service';
import ExecutionFeedback from '@/views/activitieList/component/activityDetails/ExecutionFeedback';
import activityQuality from './children/activityQuery/activityQuality';

export default {
  name: 'ActivityDetails',
  data () {
    return {
      tabsList: [
        {
          label: this.$t('newApp.activityInfo.ei'),
          name: 'activityBasicInformation'
        }
      ],
      activeName: 'activityBasicInformation',
      echoData: {},
      requestFlage: false,
      agreeDialogVisible: false,
      agreeRejectFlage: 1,
      approved: ''
    };
  },
  components: {
    commonHeader,
    activityBasicInformation,
    activistyMaterial,
    ExecutionFeedback,
    travellingTrader,
    activityQuality
  },
  methods: {
    agreeRejectBtn (val) {
      this.$refs.activityBasicInformation.agreeRejectBtn(val);
    },
    recallBtn () {
      this.$confirm(this.$t('eventList.OKRMta'), this.$t('general.Hint'), {
        confirmButtonText: this.$t('btn.OK'),
        cancelButtonText: this.$t('btn.Cancel'),
        type: 'warning'
      }).then(() => {
        this.$store.commit('setSubPageLoading', true);
        activityQuery.recallModification(this.$route.query.activityCode).then(res => {
          if (res.status === '200') {
            this.$router.push('/drafts');
            this.$message.success(this.$t('general.OperSucc'));
          }
          this.$store.commit('setSubPageLoading', false);
        });
      }).catch(() => {

      });
    },
    handleTabsClick (val) {
      this.activeName = val.name;
    },
    backBtn () {
      if (this.$route.query.addCostFlag) {
        this.$router.push('/activityQuery');
        return;
      }
      this.$router.push({
        path: this.$route.query.metaActive ? this.$route.query.metaActive : '/activityQuery'
      });
    },
    editBtn () {
      let jumpFlag = 0;
      if (this.echoData.allowEditAll) {
        // 编辑全部
        jumpFlag = 1;
      } else {
        if (this.echoData.allowEditBaseInfo) {
          // 编辑基本信息
          jumpFlag = 2;
        }
        if (this.echoData.allowEditExpenseInfo) {
          // 编辑费用归属

          // 2023.08.31修改：正常是后台返回的字段值不对，但是需要前台来改，现在需要修改为1
          //   jumpFlag = 3;
          jumpFlag = 1;
        }
      }
      sessionStorage.clear();
      this.$store.commit('newApplication/setEditFlag', jumpFlag);
      let params = {
        activityCode: this.$route.query.activityCode
      };
      if (this.$route.query.metaActive) {
        params = {
          ...params,
          metaActive: this.$route.query.metaActive
        };
      }
      if (this.echoData.marketActivity.submitType === 'quick_submit') {
        const path = this.echoData.marketActivity.reportType ? '/quickTransferApplication' : '/quickApplicationForm';
        this.$router.push({
          path,
          query: params
        });
        return;
      }
      if (this.echoData.marketActivity.submitType === 'qd_submit') {
        this.$router.push({
          path: '/editQdApplication',
          query: params
        });
        return;
      }

      if (this.echoData.marketActivity.reportType && this.echoData.marketActivity.submitType === 'normal_submit') {
        this.$router.push({
          path: '/activityTransferApplication',
          query: {
            activityCode: this.$route.query.activityCode,
            activeName: 'activityQuery',
            metaActive: '/activityQuery'
          }
        });
        return;
      }
      this.$router.push({
        path: '/editApplication',
        query: params
      });
    },
    getBasicInfoData () {
      this.$store.commit('setSubPageLoading', true);
      activityQueryDetails.getBasicInfoData(this.$route.query.activityCode).then(res => {
        if (res.status === '200') {
          let { mactExpenseBelongVOList } = res.data;
          mactExpenseBelongVOList.forEach(item => {
            if (item.advertiseExpenseDetails) {
              item.advertiseExpenseDetails.countryType = item.countryType;
            }
          });
          this.echoData = res.data;
          // 根据活动的 formType 设置简化表单状态（formType 为空时视为完整表单）
          this.$store.commit('setUseSimplifiedForm', this.echoData && this.echoData.marketActivity && this.echoData.marketActivity.formType === 'simplified');
          this.requestFlage = true;
          // showFeedBackAndJoinCustomer
          if (this.echoData.showFeedBackAndJoinCustomer) {
            // 是否显示  执行反馈  参会客户
            const foeIndex = this.tabsList.findIndex(item => item.name === 'ExecutionFeedback');
            if (foeIndex === -1) {
              this.tabsList.push({
                label: this.$t('approvalCenter.FOE'),
                name: 'ExecutionFeedback'
              });
            }
            const pcuIndex = this.tabsList.findIndex(item => item.name === 'travellingTrader');
            if (pcuIndex === -1) {
              this.tabsList.push({
                label: this.$t('approvalCenter.PCU'),
                name: 'travellingTrader'
              });
            }
            const aqIndex = this.tabsList.findIndex(item => item.name === 'ActivityQuality');
            if (aqIndex === -1 && !this.$store.state.useSimplifiedForm) {
              this.tabsList.push({
                label: this.$t('approvalCenter.ActivityQuality'),
                name: 'ActivityQuality'
              });
            }
          }
          if (this.echoData.showMaterial) {
            // 是否显示  活动物料
            const materialMovingIndex = this.tabsList.findIndex(item => item.name === 'activistyMaterial');
            if (materialMovingIndex === -1 && !this.$store.state.useSimplifiedForm) {
              this.tabsList.push({
                label: this.$t('approvalCenter.MaterialMoving'),
                name: 'activistyMaterial'
              });
            }
          }
        }
        this.$store.commit('setSubPageLoading', false);
      });
    },
    toLink () {
      this.$router.push({
        query: {
          activityCode: this.$route.query.activityCode,
          metaActive: '/activityQuery'
        }
      });
      window.location.reload();
    },
    setLang () {
      window.$core = window.$core || {};
      window.$core.locale = this.$route.query.lang === 'zh' ? 'zh' : 'en';

      window.localStorage.setItem('lang', this.$route.query.lang === 'zh' ? 'zh-CN' : 'en-US');
      commonServer.updateUserLang().then(res => {
        if (res.status === '200') {
          this.toLink();
        }
      });
    },
    updateUserLangCommand (lang) {
      window.$core = window.$core || {};
      window.$core.locale = lang === 'en-US' ? 'en' : 'zh';

      window.localStorage.setItem('lang', lang);
      commonServer.updateUserLang().then(res => {
        if (res.status === '200') {
          this.toLink();
        }
      });
    }
  },
  beforeDestroy () {
    this.$store.commit('setUseSimplifiedForm', false);
  },
  created () {
    if (this.$route.query.activityCode) {
      this.getBasicInfoData();
    }
    if (this.$route.query.activeName) {
      this.activeName = this.$route.query.activeName;
    }
  },
  mounted () {
    if (this.$route.query.lang) {
      if (localStorage.getItem('lang')) {
        if (this.$route.query.lang === 'zh') {
          if (localStorage.getItem('lang') !== 'zh-CN') {
            this.updateUserLangCommand('zh-CN');
          }
        } else {
          if (localStorage.getItem('lang') !== 'en-US') {
            this.updateUserLangCommand('en-US');
          }
        }
      } else {
        this.setLang();
      }
    };
  }
};
</script>

<style lang="scss" scoped>
</style>
